// extracted by mini-css-extract-plugin
export default {"headerContainer":"_b0dbea28","header":"_6109144f","viewMore":"_9c6eea48","itemsContainer":"_e2b49ab1"};